module.exports = __webpack_public_path__ + "img/Pom_foto.ca3806c9.png";